const DEFAULT_NAVBAR_OFFSET = 88;

/** Reads live `--header-offset` from the document root (px). */
export function getNavbarOffset(): number {
  if (typeof document === "undefined") return DEFAULT_NAVBAR_OFFSET;

  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue("--header-offset")
    .trim();

  const parsed = parseFloat(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_NAVBAR_OFFSET;
  }

  return parsed;
}
